import { getAction } from '@/api/manage.js'
import menuConfig from './menu-config.js'
export function loadSysRole(back) {
  getAction('/sp/suppliers/own-brand').then(
    (res) => {
      let menuList = []
      if (res.success) {
        if (res.result) {
          // 运营，供应商入驻才显示 Orders
          let usModeFlag = res.result.model === '4' || res.result.userSource === 2
          let menuListTemp = menuConfig.menuList
          if (!usModeFlag) {
            // 批发商
            let nonArr = ['HOME', 'ORDER', 'PRODUCT', 'CUSTOMER', 'Marketplace']
            menuListTemp = menuListTemp.filter(f => !nonArr.includes(f.name))
          } else {
            // 不是批发商要判断是否是自营，自营不显示Supplier 的 order
            if (res.result.supplierManagementModel === 2) {
              menuListTemp.forEach(element => {
                if (element.name === 'ORDER') {
                  // 2023/07/10 开放orders入口
                  // element.childrenList = element.childrenList.filter(f => f.name !== 'Orders')
                }
                //自营账号不显示售后单 add by cpgu 2024/05/31
                element.childrenList = element.childrenList.filter(childInfo => {
                  return childInfo.key !== 'service-order'
                })

              })
            }
            // 不是批发商，不显示Order菜单
            menuListTemp = menuListTemp.filter(f => f.name !== 'Orders')
          }

          // 不是isVidirect账号或者批发商不显示vidirect，不显示ViDirect菜单
          if (!res.result['isVidirect'] || res.result.userSource === 3 || res.result.userSource === 6) {
            menuListTemp = menuListTemp.filter(f => f.name !== 'ViDirect')
          }

          // 4:运营者账号

          if (res.result.model === '4') {
            // 图片库菜单只有供应商账号显示，运营账号不显示()
            menuListTemp.forEach(f => {
              f.childrenList = f.childrenList.filter(childInfo => {
                return childInfo.key !== 'images'
              })
            })
          }

          // 5:Demo 账号只显示Explore
          if (res.result.model === '100') {
            let nonArr = ['VILOCAL', 'Account Settings', 'Help Center']
            menuListTemp = menuListTemp.filter(f => nonArr.includes(f.name))
            menuListTemp.forEach(f => {
              f.childrenList = f.childrenList.filter(childInfo => {
                return childInfo.key === 'Explore'
              })
            })
          }
          menuList = menuListTemp
        }
      } else {
        this.$message.warning(res.message)
      }
      back(menuList)
    }
  )
}



// WEBPACK FOOTER //
// ./src/pages/components/loadSysRole.js